import { render } from "./SelectUser.vue?vue&type=template&id=4cec2b90"
import script from "./SelectUser.vue?vue&type=script&lang=js"
export * from "./SelectUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__